import React, {Component} from 'react';
import PrintTwoPagesDoc from './PrintTwoPagesDoc';

class PrintTwoPagesReceiptDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

  }

  componentDidMount(){

  }

  render() {
    return(
      <PrintTwoPagesDoc
        title={'ใบเสร็จรับเงิน'} 
        doc={'receipt_doc'}
        docNo={this.props.rcNo}
        param={'rc'}
      >
      </PrintTwoPagesDoc>
    )
  }
}  

export default PrintTwoPagesReceiptDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintTwoPagesReceiptDoc.js